import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchRoles = () => {
  return apiClient(ENDPOINTS.ROLE, { method: "GET" });
};

export const createRole = (roleData) => {
  return apiClient(
    ENDPOINTS.ROLE,
    { method: "POST", body: roleData },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

export const updateRole = async (roleId, roleData) => {
  return await apiClient(`${ENDPOINTS.ROLE}/${roleId}`, {
    method: "PUT",
    body: roleData,
  });
};

export const deleteRole = async (roleId) => {
  return await apiClient(`${ENDPOINTS.ROLE}/${roleId}`, {
    method: "DELETE",
  });
};


export const fetchRolePermissions = (roleId) => {
  return apiClient(ENDPOINTS.ROLE_PERMISSIONS(roleId), {
    method: "GET",
  });
};